import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { MathPage, MathHeader, useScope } from "@/components/MathShell";
import { TemplatePicker } from "@/components/math/TemplatePicker";

export default function MathTemplates() {
  const [scope] = useScope();
  const nav = useNavigate();
  const pick = (t) => { toast.success(`"${t.name}" seçildi — yeni yayın kurulumunda uygulanacak`); nav(`/matematik/yayinlar?yeni=1&tpl=${t.id}`); };
  return (
    <MathPage crumbs={["Şablonlar"]} scope={scope}>
      <MathHeader title="Hazır taslak şablonları" sub="Kitap, soru bankası, fasikül, föy ve deneme için 100 hazır şablon. Seçin, sayfa sayısını girin, yerleştirin." />
      <div className="bg-white rounded-xl border p-5"><TemplatePicker onPick={pick} /></div>
    </MathPage>
  );
}
